const action = "SEGMENT_DELETE";
export const REQUEST = action+'_REQUEST';
export const RESPONSE = action+'_RESPONSE';
export const FAILURE = action+'_FAILURE';

export const deleteSegmentRequest = (segmentId) => {
    return {
        type: REQUEST,
        payload: segmentId
    };
};

export const deleteSegmentSuccess = (response) => ({
  type: RESPONSE,
  payload: response
});

export const deleteSegmentFailure = (error) => ({
  type: FAILURE,
  payload: error
}); 